var $ = require('jquery');
$(document).on('click', '.ddlReg .list li', function (e) {
    var contactus_divId = '.contact' + $(this).attr('data-value');
    $('.con-info').hide();
    $(contactus_divId).show();
    var datavalue = $(this).text();
    $(".option").removeClass("selected focus");
    $(this).addClass("selected focus");
   // $('#ddlRegion').val($(this).attr('data-value'));
    $(".current").text(datavalue);
    //$('#ddlRegion :selected').text($(this).text());
});
$(".ddlReg").click(function()
{
    $(this).toggleClass("open");
})
$(document).ready(function () {
    if($("#HowMisconductDiscovered").length>0)
    {
    var now = new Date();
    var day = ("0" + now.getDate()).slice(-2);
    var month = ("0" + (now.getMonth() + 1)).slice(-2);
    var year = now.getFullYear() + 543;

    var today = year + "-" + (month) + "-" + (day);
    $('#HowMisconductDiscovered').val(today);
    document.getElementById("HowMisconductDiscovered").setAttribute("max", today);
    $('#btnSubmit').click(function () {
        Submit();
    });
    $('#btnSubmit1').click(function () {
        Submit1();
    });
    $('#btnSubmit2').click(function () {
        Submit2();
    });
    $('#btnSubmit3').click(function () {
        Submit4();
    });
    $(".nice-select").click(function () {
        $(this).toggleClass("open");
    })
}
});

$(function () {
    $('.textfield').not('#txtEmail,#txtEmail1,#txtEmail2,#txtEmail3').on('keypress', function (event) {
        var text = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        validateInput(text);
    });

    $('.textfield').on('paste', function (event) {
        var text = event.originalEvent.clipboardData.getData('text');
        validateInput(text);
    });
});
$(document).ready(function () {
    $("#emaildivid").hide();
    $("#contactdivid").hide();
    $("#emaildivid1").hide();
    $("#contactdivid1").hide();
    $("#emaildivid2").hide();
    $("#contactdivid2").hide();

    $(function () {
        $("#checkPhone").click(function () {
            $("#contactdivid").toggle();

        });
        $("#checkPhone1").click(function () {
            $("#contactdivid1").toggle();

        });
        $("#checkPhone2").click(function () {
            $("#contactdivid2").toggle();

        });

    });
    $(function () {
        $("#checkEmail").click(function () {
            $("#emaildivid").toggle();
        });
        $("#checkEmail1").click(function () {
            $("#emaildivid1").toggle();
        });
        $("#checkEmail2").click(function () {
            $("#emaildivid2").toggle();
        });
    });
    $('.contact-us').show();
    var valCount = 0
    var $regContactnumber = /^[\d\-\s]*$/;

    var $regexname = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    $('#txtEmail').on('keypress keydown keyup', function (e) {
        if (!$(this).val().match($regexname)) {
            // there is a mismatch, hence show the error message
            $("#spemail").text("Wrong email format!");
            valCount = valCount + 1;
        }
        else {
            // else, do not display message
            valCount = 0;
            $("#spemail").text("");
        }
    });
    $('#txtEmail1').on('keypress keydown keyup', function (e) {
        if (!$(this).val().match($regexname)) {
            // there is a mismatch, hence show the error message
            $("#spemail1").text("Wrong email format!");
            valCount = valCount + 1;
        }
        else {
            // else, do not display message
            valCount = 0;
            $("#spemail1").text("");
        }
    });
    $('#txtEmail2').on('keypress keydown keyup', function (e) {
        if (!$(this).val().match($regexname)) {
            // there is a mismatch, hence show the error message
            $("#spemail2").text("Wrong email format!");
            valCount = valCount + 1;
        }
        else {
            // else, do not display message
            valCount = 0;
            $("#spemail2").text("");
        }
    });

    $('#txtEmail3').on('keypress keydown keyup', function (e) {
        if (!$(this).val().match($regexname)) {
            // there is a mismatch, hence show the error message
            $("#spemail3").text("Wrong email format!");
            valCount = valCount + 1;
        }
        else {
            // else, do not display message
            valCount = 0;
            $("#spemail3").text("");
        }
    });

    $('#txtName').on('keypress keydown keyup', function () {
        var Name = $("#txtName").val();
        if (Name == '' || Name == null) {
            valCount = valCount + 1;
            $("#spName").text("กรุณากรอกชื่อ");
        }
        else {
            $("#spName").text("");
        }
    });

    //$(":input").keyup(function () {

    //    $('.ErrorSpan').text("");
    //});

    $('#checkAgree').click(function () {
        if ($('#checkAgree').is(':checked')) {
            $("#spAccept").text('');
        }
    });
});

function Validate_Sign_Complete() {

}

function Submit() {

    var token = $('input[name="__RequestVerificationToken"]').val();
    var Name = $("#txtName").val();
    var contactnumber = $("#txtContactnumber").val();
    var email = $("#txtEmail").val();
    var SubEmail = $("#contactusEmail").val();
    var Description = $("#question").val();
    var callmeback = $('#checkPhone').is(':checked');
    if (callmeback)
        var data = "Call me back";
    else
        var data = "NO";
    var replyme = $('#checkEmail').is(':checked');
    if (replyme)
        data1 = "Reply to me";
    else
        data1 = "NO";

    var Region = $('#ddlRegion :selected').text();
    var contactnumber = $("#txtContactnumber").val();
    //var email = $("#txtEmail").val();
    var gender = $("input[name='gender']:checked").val();
    var Surname = $("#txtSurname").val();
    var Topic = $("#txtTopic").val();
    var valCount = 0;

    if (Name == '' || Name == null) {
        valCount = valCount + 1;
        $("#spName").text("กรุณากรอกชื่อ");
    }
    else
        $("#spName").text("");
    if (Topic == '' || Topic == null) {
        valCount = valCount + 1;
        $("#spTopic").text("Please Enter Topic");
    }
    else
        $("#spTopic").text("");

    if (data == "NO" && data1 == "NO") {
        $("#spcontactway").text("กรุณาเลือกช่องทางการติดต่อ");
        return false;
    }
    else
        $("#spcontactway").text("");

    if (valCount > 0)
        flag = 'false';
    else
        flag = 'true';

    if (flag == 'true') {

        if (grecaptcha.getResponse().length == 0) {
            alert('Oops, you have to check the recaptcha !');
            return false;
        }
        if ($('#checkAgree').is(':checked')) {
            $("#spAccept").text('');

            var location = window.location.href;
            var locat = '';
            if (location.indexOf('?'))
                locat = location.split('?')[0];
            else
                locat = location;
            $.ajax({
                type: 'post',
                // url:'@Url.Action("Contactus", "TH_ContactUs")',
                // url: '/contactus/Contactus',
                url: locat + '/Contactus', //?__RequestVerificationToken=' + token + '&Name=' + Name + '&contactnumber=' + contactnumber + '&email=' + email + '&Subject=' + Description + '&callmeback=' + data + '&replyme=' + data1 + '&Message=' + Region + '&gender=' + gender + '&Surname=' + Surname + '&Topic=' + Topic + '&SubEmail=' + SubEmail,
                data: { __RequestVerificationToken: token, Name: Name, contactnumber: contactnumber, email: email, Subject: Description, callmeback: data, replyme: data1, Message: Region, gender: gender, Surname: Surname, Topic: Topic, SubEmail: SubEmail },
                //data:{Name:Name,contactnumber: contactnumber},
                dataType: "json",
                success: function (data) {
                    if (data = ! "Success") {
                        alert("ระบบเกิดความขัดข้อง กรุณาลองอีกครั้ง");

                    }
                    else
                        $('.contact-info').hide();
                    grecaptcha.reset();
                    $('.divrow').hide();
                    $('.message').show();
                    window.scrollTo(0, 0);

                },
                failure: function (response) {
                    alert("Failed " + response.responseText);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    // alert(xhr.status);
                    // alert(thrownError);
                }
            });
        }
        else {
            $("#spAccept").text('คุณยังไม่ได้อ่านคำเตือนในการยินยอมให้ใช้ข้อมูลส่วนตัวตามกฎหมายการป้องกันข้อมูลส่วนบุคคลและยังไม่ตอบรับการใช้ข้อมูลตามวัตถุประสงค์ดังกล่าว กรุณาตรวจสอบและส่งใหม่อีกครั้ง');

            return false;
        }
    }
    else {
       // console.log('//error');

    }
}
function Submit1() {

    var token = $('input[name="__RequestVerificationToken"]').val();
    var Name = $("#txtName1").val();
    var contactnumber = $("#txtContactnumber1").val();
    var email = $("#txtEmail1").val();
    var SubEmail = $("#FeedbackEmail").val();
    var Message = $('#ddlRegion :selected').text();
    var callmeback = $('#checkPhone1').is(':checked');
    if (callmeback)
        var data = "Call me back";
    else
        var data = "NO";
    var replyme = $('#checkEmail1').is(':checked');
    if (replyme)
        data1 = "Reply to me";
    else
        data1 = "NO";
    var contactnumber = $("#txtContactnumber1").val();
    var gender = $("input[name='gender1']:checked").val();
    var Surname = $("#txtSurname1").val();
    var Topic = $("#txtTopic1").val();
    var RelatedTo = $("input[name='RelatedTo1']:checked").val();
    var Details = $("#txtDetails1").val();
    var address = $("#txtAddress1").val();
    var UnitHolder = $('input:text[name=UnitHolder1]').val();
    var Fax = $('input:text[name=Fax1]').val();
    var valCount = 0;
    if (RelatedTo == "Others") {
        RelatedTo = $("#txtOtherIssues").val();
    }
    if (Name == '' || Name == null) {
        valCount = valCount + 1;
        $("#spName1").text("กรุณากรอกชื่อ");
    }
    else
        $("#spName1").text("");
    if (Topic == '' || Topic == null) {
        valCount = valCount + 1;
        $("#spTopic1").text("Please Enter Topic");
    }
    else
        $("#spTopic1").text("");
    if (Details == '' || Details == null) {
        valCount = valCount + 1;
        $("#spDetail1").text("Please Enter Details");
    }
    else
        $("#spDetail1").text("");

    if (data == "NO" && data1 == "NO") {
        $("#spcontactway1").text("กรุณาเลือกช่องทางการติดต่อ");
        return false;
    }
    else
        $("#spcontactway1").text("");

    if (valCount > 0)
        flag = 'false';
    else
        flag = 'true';

    if (flag == 'true') {

        if (grecaptcha.getResponse().length == 0) {
            alert('Oops, you have to check the recaptcha !');
            return false;
        }
        if ($('#checkAgree1').is(':checked')) {
            $("#spAccept1").text('');
            var location = window.location.href;
            var locat = '';
            if (location.indexOf('?'))
                locat = location.split('?')[0];
            else
                locat = location;
            $.ajax({
                type: 'post',
                url: locat + '/ContactusFeedback',
                data: { __RequestVerificationToken: token, Name: Name, contactnumber: contactnumber, email: email, callmeback: data, replyme: data1, gender: gender, Surname: Surname, Topic: Topic, UnitHolder: UnitHolder, address: address, Fax: Fax, RelatedTo: RelatedTo, Details: Details, SubEmail: SubEmail, Message: Message },
                dataType: "json",
                success: function (data) {
                    if (data = ! "Success") {
                        alert("ระบบเกิดความขัดข้อง กรุณาลองอีกครั้ง");

                    }
                    else
                        $('.contact-info').hide();
                    grecaptcha.reset();
                    $('.divrow').hide();
                    $('.message').show();
                    window.scrollTo(0, 0);

                },
                failure: function (response) {
                    alert("Failed " + response.responseText);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    alert(xhr.status);
                    alert(thrownError);
                }
            });
        }
        else {
            $("#spAccept1").text('คุณยังไม่ได้อ่านคำเตือนในการยินยอมให้ใช้ข้อมูลส่วนตัวตามกฎหมายการป้องกันข้อมูลส่วนบุคคลและยังไม่ตอบรับการใช้ข้อมูลตามวัตถุประสงค์ดังกล่าว กรุณาตรวจสอบและส่งใหม่อีกครั้ง');

            return false;
        }
    }
    else {
       // console.log('//error');

    }
}

function Submit2() {
    var token = $('input[name="__RequestVerificationToken"]').val();
    var Name = $("#txtName2").val();
    var contactnumber = $("#txtContactnumber2").val();
    var email = $("#txtEmail2").val();
    var SubEmail = $("#OnlineComplaintEmail").val();
    var Message = $('#ddlRegion :selected').text();
    var callmeback = $('#checkPhone2').is(':checked');
    if (callmeback)
        var data = "Call me back";
    else
        var data = "NO";
    var replyme = $('#checkEmail2').is(':checked');
    if (replyme)
        data1 = "Reply to me";
    else
        data1 = "NO";
    var contactnumber = $("#txtContactnumber2").val();
    var gender = $("input[name='gender2']:checked").val();
    var Surname = $("#txtSurname2").val();
    var Topic = $("#txtTopic2").val();
    var RelatedTo = $("input[name='RelatedTo2']:checked").val();
    var Details = $("#txtDetails2").val();
    var address = $("#txtAddress2").val();
    var UnitHolder = $('input:text[name=UnitHolder2]').val();
    var Fax = $('input:text[name=Fax2]').val();
    var valCount = 0;
    if (RelatedTo == "Others") {
        RelatedTo = $("#txtOtherIssues1").val();
    }
    if (Name == '' || Name == null) {
        valCount = valCount + 1;
        $("#spName2").text("กรุณากรอกชื่อ");
    }
    else
        $("#spName2").text("");
    if (Topic == '' || Topic == null) {
        valCount = valCount + 1;
        $("#spTopic2").text("Please Enter Topic");
    }
    else
        $("#spTopic2").text("");
    if (Details == '' || Details == null) {
        valCount = valCount + 1;
        $("#spDetail2").text("Please Enter Details");
    }
    else
        $("#spDetail2").text("");
    if (data == "NO" && data1 == "NO") {
        $("#spcontactway2").text("กรุณาเลือกช่องทางการติดต่อ");
        return false;
    }
    else
        $("#spcontactway2").text("");

    if (valCount > 0)
        flag = 'false';
    else
        flag = 'true';

    if (flag == 'true') {

        if (grecaptcha.getResponse().length == 0) {
            alert('Oops, you have to check the recaptcha !');
            return false;
        }
        if ($('#checkAgree2').is(':checked')) {
            $("#spAccept2").text('');
            var location = window.location.href;
            var locat = '';
            if (location.indexOf('?'))
                locat = location.split('?')[0];
            else
                locat = location;
            $.ajax({
                type: 'post',
                url: locat + '/OnlineComplaint',
                data: { __RequestVerificationToken: token, Name: Name, contactnumber: contactnumber, email: email, callmeback: data, replyme: data1, gender: gender, Surname: Surname, Topic: Topic, UnitHolder: UnitHolder, address: address, Fax: Fax, RelatedTo: RelatedTo, Details: Details, SubEmail: SubEmail, Message: Message },
                dataType: "json",
                success: function (data) {
                    if (data = ! "Success") {
                        alert("ระบบเกิดความขัดข้อง กรุณาลองอีกครั้ง");

                    }
                    else
                        $('.contact-info').hide();
                    grecaptcha.reset();
                    $('.divrow').hide();
                    $('.message').show();
                    window.scrollTo(0, 0);

                },
                failure: function (response) {
                    alert("Failed " + response.responseText);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    alert(xhr.status);
                    alert(thrownError);
                }
            });
        }
        else {
            $("#spAccept2").text('คุณยังไม่ได้อ่านคำเตือนในการยินยอมให้ใช้ข้อมูลส่วนตัวตามกฎหมายการป้องกันข้อมูลส่วนบุคคลและยังไม่ตอบรับการใช้ข้อมูลตามวัตถุประสงค์ดังกล่าว กรุณาตรวจสอบและส่งใหม่อีกครั้ง');

            return false;
        }
    }
    else {
        //console.log('//error');

    }
}

function Submit4() {
    var token = $('input[name="__RequestVerificationToken"]').val();
    var Name = $("#txtName3").val();
    var contactnumber = $("#txtContactnumber3").val();
    var email = $("#txtEmail3").val();

    var Message = $('#ddlRegion :selected').text();
    var gender = $("input[name='gender3']:checked").val();
    var Surname = $("#txtSurname3").val();
    var whomToSubmit = $('#whomToSubmit :selected').text();
    var HowMisconductDiscovered = $("#HowMisconductDiscovered").val();
    var Locationofmisconduct = $("#Locationofmisconduct").val();
    var Nameofindividualsinvolved = $("#Nameofindividualsinvolved").val();
    var Departmentinvolved = $("#Departmentinvolved").val();
    var Descriptionofmisconduct = $("#Descriptionofmisconduct").val();
    var ContactPreference = $("input[name='ContactPreference']:checked").val();
    var address = $("#txtAddress3").val();
    var valCount = 0;
    var MngMail = '';
    var whomToSubmitvaild = $('#whomToSubmit :selected').val();
    if (whomToSubmitvaild == 1) {
        MngMail = $("#DropdownEmail1").val();
    }
    else if (whomToSubmitvaild == 2) {
        MngMail = $("#DropdownEmail2").val();
    }
    else
        MngMail = $("#DropdownEmail3").val();

    if (Name == '' || Name == null) {
        valCount = valCount + 1;
        $("#spName3").text("กรุณากรอกชื่อ");
    }
    else
        $("#spName3").text("");
    if (HowMisconductDiscovered == '' || HowMisconductDiscovered == null) {
        valCount = valCount + 1;
        $("#spHowMisconductDiscovered").text("Please Enter How Misconduct Discovered");
    }
    else
        $("#spHowMisconductDiscovered").text("");

    if (Departmentinvolved == '' || Departmentinvolved == null) {
        valCount = valCount + 1;
        $("#spDepartmentinvolved").text("Please Enter Department involved");
    }
    else
        $("#spDepartmentinvolved").text("");

    if (Locationofmisconduct == '' || Locationofmisconduct == null) {
        valCount = valCount + 1;
        $("#spLocationofmisconduct").text("Please Enter Location of misconduct");
    }
    else
        $("#spLocationofmisconduct").text("");

    if (Nameofindividualsinvolved == '' || Nameofindividualsinvolved == null) {
        valCount = valCount + 1;
        $("#spNameofindividualsinvolved").text("Please Enter Name of individualsinvolved");
    }
    else
        $("#spNameofindividualsinvolved").text("");
    if (Descriptionofmisconduct == '' || Descriptionofmisconduct == null) {
        valCount = valCount + 1;
        $("#spDescriptionofmisconduct").text("Please Enter Description of misconduct");
    }
    else
        $("#spDescriptionofmisconduct").text("");
    if (whomToSubmitvaild == -1) {
        valCount = valCount + 1;
        $("#spwhomToSubmit").text("Please Enter Whom ToSubmit this form");
    }
    else
        $("#spwhomToSubmit").text("");

    if (contactnumber == '' || contactnumber == null) {
        valCount = valCount + 1;
        $("#spcontact3").text("contact number is required.");
    }
    else
        $("#spcontact3").text("");

    if (email == '' || email == null) {
        valCount = valCount + 1;
        $("#spemail3").text("Email is required.");
    }
    else
        $("#spemail3").text("");
    var flag = false;

    if (valCount > 0)
        flag = 'false';
    else
        flag = 'true';

    if (flag == 'true') {
        if (grecaptcha.getResponse().length == 0) {
            alert('Oops, you have to check the recaptcha !');
            return false;
        }
        if ($('#checkAgree3').is(':checked')) {
            $("#spAccept3").text('');
            if (whomToSubmitvaild != -1) {
                var location = window.location.href;
                var locat = '';
                if (location.indexOf('?'))
                    locat = location.split('?')[0];
                else
                    locat = location;
                $.ajax({
                    type: 'post',
                    url: locat + '/Whistleblowing',
                    data: {
                        __RequestVerificationToken: token, Name: Name, contactnumber: contactnumber, email: email, gender: gender, Surname: Surname, address: address, whomToSubmit: whomToSubmit, HowMisconductDiscovered: HowMisconductDiscovered,
                        Locationofmisconduct: Locationofmisconduct, Departmentinvolved: Departmentinvolved, Nameofindividualsinvolved: Nameofindividualsinvolved, Descriptionofmisconduct: Descriptionofmisconduct, ContactPreference: ContactPreference, MngMail: MngMail, Message: Message
                    },
                    dataType: "json",
                    success: function (data) {
                        if (data = ! "Success") {
                            alert("ระบบเกิดความขัดข้อง กรุณาลองอีกครั้ง");

                        }
                        else
                            $('.contact-info').hide();
                        grecaptcha.reset();
                        $('.divrow').hide();
                        $('.message').show();
                        window.scrollTo(0, 0);

                    },
                    failure: function (response) {
                        alert("Failed " + response.responseText);
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        // alert(xhr.status);
                        //alert(thrownError);
                    }
                });
            }
        }
        else {
            $("#spAccept3").text('คุณยังไม่ได้อ่านคำเตือนในการยินยอมให้ใช้ข้อมูลส่วนตัวตามกฎหมายการป้องกันข้อมูลส่วนบุคคลและยังไม่ตอบรับการใช้ข้อมูลตามวัตถุประสงค์ดังกล่าว กรุณาตรวจสอบและส่งใหม่อีกครั้ง');

            return false;
        }
    }
    else {
        //console.log('//error');

    }
}